import { WizardLayout } from '../../components/wizard/WizardLayout';
import { WizardStep } from '../../components/wizard/WizardStep';
import { de } from '../../lib/i18n/de';
import { useDimensionForm } from '../../components/wizard/fields/useDimensionForm';
import {
  BooleanField,
  SelectField,
  TextareaField,
  type Option,
} from '../../components/wizard/fields/FormFields';
import { PRIVATE_KEYS } from '../../lib/store/dimensionScoreInput';
import { DimensionLiveScore } from '../../components/wizard/fields/DimensionLiveScore';
import { SensitiveNote } from '../../components/wizard/fields/SensitiveNote';

const t = de.dimensionFields.private;

const CHILDCARE_OPTIONS: Option[] = Object.entries(t.childcareOptions).map(([value, label]) => ({
  value,
  label,
}));

export function PrivateStep() {
  const form = useDimensionForm('private');
  const hasContent = Object.values(form.fields).some((v) => v.trim().length > 0);

  return (
    <WizardLayout>
      <WizardStep
        stepId="private"
        canProceed={hasContent}
        lastSavedAt={form.lastSavedAt}
        saveState={form.lastSavedAt ? 'saved' : 'idle'}
        onProceed={form.markComplete}
      >
        <div className="space-y-8">
          <SensitiveNote>{t.sensitiveNote}</SensitiveNote>
          <SelectField
            id="private-childcare"
            label={t.childcareStatusLabel}
            hint={t.childcareStatusHint}
            options={CHILDCARE_OPTIONS}
            helpKey="private.care"
            value={form.get(PRIVATE_KEYS.childcareStatus)}
            onChange={(v) => {
              form.set(PRIVATE_KEYS.childcareStatus, v);
            }}
          />
          <BooleanField
            id="private-care"
            label={t.hasCareResponsibilityLabel}
            required
            value={form.get(PRIVATE_KEYS.hasCareResponsibility)}
            onChange={(v) => {
              form.set(PRIVATE_KEYS.hasCareResponsibility, v);
            }}
          />
          <TextareaField
            id="private-care-desc"
            label={t.careDescriptionLabel}
            hint={t.careDescriptionHint}
            minLength={30}
            value={form.get(PRIVATE_KEYS.careResponsibilityDescription)}
            onChange={(v) => {
              form.set(PRIVATE_KEYS.careResponsibilityDescription, v);
            }}
          />
          <TextareaField
            id="private-zumutbarkeit"
            label={t.zumutbarkeitLabel}
            hint={t.zumutbarkeitHint}
            minLength={50}
            rows={5}
            value={form.get(PRIVATE_KEYS.zumutbarkeitsgruende)}
            onChange={(v) => {
              form.set(PRIVATE_KEYS.zumutbarkeitsgruende, v);
            }}
          />
          <TextareaField
            id="private-regional"
            label={t.regionalContextLabel}
            hint={t.regionalContextHint}
            minLength={30}
            value={form.get(PRIVATE_KEYS.regionalLaborMarketContext)}
            onChange={(v) => {
              form.set(PRIVATE_KEYS.regionalLaborMarketContext, v);
            }}
          />
          <TextareaField
            id="private-notes"
            label={de.dimensionFields.common.notesLabel}
            hint={de.dimensionFields.common.notesHint}
            placeholder={de.dimensionFields.common.notesPlaceholder}
            rows={3}
            value={form.get(PRIVATE_KEYS.notes)}
            onChange={(v) => {
              form.set(PRIVATE_KEYS.notes, v);
            }}
          />
          <DimensionLiveScore dimension="private" fields={form.fields} />
        </div>
      </WizardStep>
    </WizardLayout>
  );
}
